<template>
    <section class="hero is-medium">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">
                    <h3 class="title has-text-grey">Bet'N GO</h3>
                    <div class="box">
                        <form @submit.prevent="doLogin" class="login-form">
                            <div class="field">
                                <div class="control">
                                    <input
                                        class="input is-large"
                                        type="text"
                                        placeholder="Login"
                                        autofocus
                                        v-model="login"
                                    />
                                </div>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <input
                                        class="input is-large"
                                        type="password"
                                        placeholder="Password"
                                        v-model="password"
                                    />
                                </div>
                            </div>
                            <button class="button is-block is-info is-large is-fullwidth">Login</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import userService from '../services/user.service';
import clientService from '../services/client.service';
import currencyService from '../services/currency.service';
import timezoneService from '../services/timezone.service';
import state from '../state';

export default {
    name: 'login',
    data() {
        return {
            login: null,
            password: null
        };
    },
    methods: {
        async doLogin() {
            const response = await userService.login({ login: this.login, password: this.password });
            if (response && response.isSuccess) {
                state.admin.set(response.admin);
                await clientService.ensure();
                await currencyService.ensure();
                await timezoneService.ensure();

                this.$router.push('/');
            } else {
                alert(`Login failed: ${response.error}`);
            }
        }
    }
};
</script>
<style scoped>
.login-form {
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// front/src/components/login.vue